var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTonne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.182 0h10.636C12.47 0 13 .53 13 1.182v10.636C13 12.47 12.47 13 11.818 13H1.182C.53 13 0 12.47 0 11.818V1.182C0 .53.53 0 1.182 0zM2.74 3.748L4.41 5.42a.295.295 0 00.419 0c.586-.586 1.459-.78 2.242-.595l.637-1.4a.295.295 0 11.538.245l-.62 1.364a2.2 2.2 0 01.545.386.295.295 0 00.418 0l1.671-1.67a.295.295 0 000-.419A5.282 5.282 0 006.5 1.773c-1.42 0-2.756.553-3.76 1.558a.295.295 0 000 .417z",
    fill: "#A4A4A4"
  })));
}

export default SvgTonne;